import type { RecentNewsProps } from "./types";

import Link from "@/components/link";
import { NewsArticleCard } from "@/components/blocks/news-article-card";
import { Heading } from "@digdir/designsystemet-react";
import { ArrowRightIcon } from "@navikt/aksel-icons";

export type { RecentNewsProps };

export const RecentNewsBlock = ({
  blockHeading,
  articles,
  showMoreNewsLink,
  moreNewsUrl,
  moreNewsText,
}: RecentNewsProps) => {
  return (
    <>
      <Heading className="heading-md mb-0">{blockHeading}</Heading>

      <div className="w-full lg:grid justify-start gap-5 lg:grid-cols-3">
        {articles.map((article) => (
          <NewsArticleCard
            url={article.url}
            heading={article.heading}
            introText={article.introText}
            imageUrl={article.imageUrl}
            imgAltText={article.imgAltText}
          />
        ))}
      </div>

      {showMoreNewsLink && moreNewsUrl && (
        <Link href={moreNewsUrl}>
          {moreNewsText}
          <ArrowRightIcon />
        </Link>
      )}
    </>
  );
};
